var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"affairs flex-wrap"},[_c('AuthorAffairsSection',{attrs:{"taskAuthorList":_vm.taskAuthorList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }